
























import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      allowedChars: [
        ["Space", "&", "*", "(", "2", "A", "I", "Q", "Y", "g", "o", "w"],
        ["“", ".", "+", ")", "3", "B", "J", "R", "Z", "h", "p", "x"],
        ["‘", ",", "-", "4", "C", "K", "S", "a", "i", "q", "y"],
        ["!", ":", "=", "5", "D", "L", "T", "b", "j", "r", "z"],
        ["@", ";", "_", "6", "E", "M", "U", "c", "k", "s", " "],
        ["#", "<", "/", "7", "F", "N", "V", "d", "l", "t", " "],
        ["$", ">", "0", "8", "G", "O", "W", "e", "m", "u", " "],
        ["%", "?", "1", "9", "H", "P", "X", "f", "n", "v", " "],
      ],
    };
  },
});
